import { render, staticRenderFns } from "./OverviewTableTemplateSubmission.vue?vue&type=template&id=64981447&"
import script from "./OverviewTableTemplateSubmission.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableTemplateSubmission.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTableTemplateSubmission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports